module.exports = __webpack_public_path__ + "ae048a7fa43e0e682a3f11f0cd615f40.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/harvard_university_2_2023_chart.png
// module id = 1685
// module chunks = 0